import { render, staticRenderFns } from "./ActivationLayout.vue?vue&type=template&id=c5761698&scoped=true"
import script from "./ActivationLayout.vue?vue&type=script&lang=js"
export * from "./ActivationLayout.vue?vue&type=script&lang=js"
import style0 from "./ActivationLayout.vue?vue&type=style&index=0&id=c5761698&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5761698",
  null
  
)

export default component.exports